import axios from "axios";
import React, { useEffect, useState } from "react";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import EnquiryDetailsModal from "../../Modals/EnquiryDetailsModal";

const NewlyInquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ text: "", type: "" });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);

  useEffect(() => {
    fetchInquiries();
  }, []);

  const fetchInquiries = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/form/get-all-inquiries`
      );

      const inquiriesData = Array.isArray(response.data)
        ? response.data
        : response.data.inquiries
        ? response.data.inquiries
        : response.data.data
        ? response.data.data
        : response.data.inquiry
        ? [response.data.inquiry]
        : [];

      setInquiries(inquiriesData.filter((inq) => inq.status === "Pending"));
    } catch (error) {
      console.error("Error fetching inquiries:", error);
      setInquiries([]);
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type) => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: "", type: "" }), 3000);
  };

  const updateStatus = async (inq, newStatus) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/form/update-inquiry/${inq._id}`,
        { status: newStatus }
      );

      if (response.data.success) {
        setInquiries((prev) => prev.filter((item) => item._id !== inq._id));
      } else showMessage("Failed to update status", "error");
    } catch (error) {
      console.error("Error updating status:", error);
      showMessage("Error updating status", "error");
    }
  };

  const openModal = (inquiry) => {
    setSelectedInquiry(inquiry);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedInquiry(null);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border border-gray-200 rounded-lg shadow-lg table-auto">
        <thead className="bg-gradient-to-r from-[#0070a8] to-[#023955] text-white">
          <tr>
            {["Name", "Contact", "Email", "Certificate", "Date", "Actions"].map(
              (col) => (
                <th
                  key={col}
                  className={`px-4 py-3 text-left text-sm md:text-base font-semibold uppercase tracking-wider ${
                    col === "Actions" ? "text-center" : ""
                  }`}
                >
                  {col}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <tr key={index} className="animate-pulse">
                {Array.from({ length: 6 }).map((__, idx) => (
                  <td
                    key={idx}
                    className="px-4 py-4 whitespace-nowrap bg-gray-100 rounded"
                  >
                    &nbsp;
                  </td>
                ))}
              </tr>
            ))
          ) : inquiries.length > 0 ? (
            inquiries.map((inq) => (
              <tr
                key={inq._id}
                className="hover:bg-[#f0f8ff] transition-colors duration-300"
              >
                <td className="px-4 py-3 text-gray-900 font-medium">
                  {inq.name || "N/A"}
                </td>
                <td className="px-4 py-3 text-gray-800">
                  {inq.mobile || "N/A"}
                </td>
                <td
                  className="px-4 py-3 text-gray-800 truncate max-w-[180px]"
                  title={inq.email}
                >
                  {inq.email || "example@gmail.com"}
                </td>
                <td
                  className="px-4 py-3 text-gray-800 truncate max-w-[180px]"
                  title={inq.subject}
                >
                  {inq.subject
                    ? inq.subject.length > 20
                      ? inq.subject.slice(0, 20) + "..."
                      : inq.subject
                    : "N/A"}
                </td>
                <td className="px-4 py-3 text-gray-800">
                  {inq.createdAt
                    ? new Date(inq.createdAt).toLocaleDateString()
                    : "N/A"}
                </td>
                <td className="px-4 py-3 text-center">
                  <div className="flex justify-center gap-2">
                    <button
                      onClick={() => updateStatus(inq, "reserved")}
                      className="p-1 rounded-full bg-gradient-to-r from-[#0a74c2] to-[#024a6b] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white transition-all"
                      title="Mark as Interested"
                    >
                      <IoCheckmarkDoneCircleOutline size={20} />
                    </button>

                    <button
                      onClick={() => updateStatus(inq, "rejected")}
                      className="p-1 rounded-full bg-gradient-to-r from-[#c20000] to-[#750000] hover:from-[#ff4d4d] hover:to-[#a10000] text-white transition-all"
                      title="Mark as Not Interested"
                    >
                      <FaRegCircleXmark size={20} />
                    </button>

                    <button
                      onClick={() => openModal(inq)}
                      className="p-1 rounded-full bg-gradient-to-r from-[#4a90e2] to-[#357abd] hover:from-[#5ba0f2] hover:to-[#4a90e2] text-white transition-all"
                      title="View Details"
                    >
                      <FaEye size={20} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="6"
                className="text-center py-6 text-gray-500 text-sm"
              >
                No pending inquiries
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {message.text && (
        <div
          className={`fixed bottom-4 right-4 px-4 py-2 rounded shadow-lg text-white transition-all duration-500 transform ${
            message.type === "success" ? "bg-green-600" : "bg-red-600"
          }`}
        >
          {message.text}
        </div>
      )}

      <EnquiryDetailsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        inquiry={selectedInquiry}
      />
    </div>
  );
};

export default NewlyInquiries;
